// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimesheetEntryVM  {
    _originalTypeClassName = "Loom.BO.TimesheetEntryVM";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimesheetEntryVM.translate = translateService;
}
this.Id = null;
this.HoursWorked = null;
this.WPId = null;
this.WPNumber = null;
this.WPTitle = null;
this.ProjectAcronym = null;
this.FQN = null;
this.WPStartDate = null;
this.WPEndDate = null;
this.Month = null;
this.DateSubmitted = null;
this.DateApproved = null;
this.Status = null;
this.Approver = null;
this.SubmittedBy = null;
this.Employee = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
HoursWorked:any;
WPId:any;
WPNumber:any;
WPTitle:any;
ProjectAcronym:any;
FQN:any;
WPStartDate:any;
WPEndDate:any;
Month:any;
DateSubmitted:any;
DateApproved:any;
Status:any;
Approver:any;
SubmittedBy:any;
Employee:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}